export const constructGraphData = (data) => {
  if (!data) return [];
  return Object.entries(data).map(([date, value]) => ({
    x: new Date(date).getTime(),
    y: value,
  }));
};
